import { render, staticRenderFns } from "./AccountSettingSegmentation.vue?vue&type=template&id=41ed970a&"
import script from "./AccountSettingSegmentation.vue?vue&type=script&lang=js&"
export * from "./AccountSettingSegmentation.vue?vue&type=script&lang=js&"
import style0 from "./AccountSettingSegmentation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports